import { CalendarClock, CalendarDays, Sparkles } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Calendar — the content calendar (PRD §8 Item 11, US-11.1) and the meetings
 * that share its month grid. Booking pages stay a placeholder until roadmap
 * item 16 lands.
 *
 * `/calendar?item=<id>` and `/calendar?meeting=<id>` are fixed by ENTITY_ROUTES:
 * the API puts those URLs into notifications and e-mails, so this feature must
 * serve them.
 */
export default defineFeature({
  key: "calendar",
  title: "Calendar",
  entities: ["content_item", "meeting"],
  routes: [{ path: "calendar", lazy: () => import("./page") }],
  publicRoutes: [{ path: "/book/:slug", lazy: () => import("./public") }],
  nav: [
    {
      label: "Calendar",
      to: "/calendar",
      icon: CalendarDays,
      group: "delivery",
      order: 40,
      description: "Planned content, approvals and meetings",
    },
  ],
  quickCreate: [
    {
      key: "content-item",
      label: "Planned post",
      icon: CalendarDays,
      to: "/calendar?new=1",
      permission: "calendar:write",
      description: "Add one post to a client's month",
    },
  ],
  commands: [
    { key: "calendar.month", label: "Content calendar", icon: CalendarDays, to: "/calendar", group: "navigate", keywords: ["posts", "schedule", "month"] },
    {
      key: "calendar.generate",
      label: "Fill a month from the retainer",
      icon: Sparkles,
      to: "/calendar",
      group: "actions",
      permission: "calendar:write",
      keywords: ["bulk", "quota", "placeholders", "generate"],
    },
    { key: "calendar.book", label: "Booking page", icon: CalendarClock, to: "/calendar", group: "navigate", keywords: ["meeting", "availability"] },
  ],
});
